import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRowNote } from "@services/subscriberSyncUpload";

// Note-only edit for a single Subscriber Sync upload row. Wraps updateRowNote
// (PATCH .../rows/:id/note) and invalidates the draft query so a subsequent
// refetch reflects the persisted note. Mirrors useUpdateSubscriberSyncRow.
export function useUpdateSubscriberSyncRowNote(options: any = {}) {
  const queryClient = useQueryClient();

  return useMutation(updateRowNote, {
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ["subscriberSyncUpload", variables.uploadId],
      });
    },
    ...options,
  });
}
